<template>
  <div class="areaDetail">
    <h2>{{businessRegionName}}</h2>
    <div class="dateSearch">
      <el-form :inline="true" :model="searchForm" :rules="searchFormRules" ref="searchForm" label-position="left">
        <el-form-item label="店铺别名 : " prop="vendorAliasId">
          <el-select v-model="searchForm.vendorAliasId" multiple collapse-tags filterable clearable placeholder="请选择店铺别名">
            <el-option v-for="item in vendorList" :key="item.vendorId" :label="item.vendorNameAlias" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺名称 : " prop="vendorId">
          <el-select v-model="searchForm.vendorId" multiple collapse-tags filterable clearable placeholder="请选择店铺名称">
            <el-option v-for="item in vendorList" :key="item.vendorId" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国家 : " prop="addressCountryIdList">
          <el-select v-model="searchForm.addressCountryIdList" multiple collapse-tags filterable clearable placeholder="请选择国家">
            <el-option v-for="item in countryList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商务运营 : " prop="boutiqueSaleConcatId">
          <el-select v-model="searchForm.boutiqueSaleConcatId" filterable clearable placeholder="请选择商务运营">
            <el-option v-for="item in boutiqueBdList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运营助理 : " prop="boutiqueAssistantId">
          <el-select v-model="searchForm.boutiqueAssistantId" filterable clearable placeholder="请选择运营助理">
            <el-option v-for="item in boutiqueBdList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <br>
        <el-form-item label="查询时间 : " prop="searchDate">
          <el-date-picker value-format="timestamp" :default-time="['00:00:00', '23:59:59']" clearable placeholder="请选择时间" v-model="searchForm.searchDate" type="daterange"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <span class="tips">(时间跨度不能超过一个月)</span>
        <span class="form-btn">
          <el-button size="medium" type="primary" @click="searchAreaList">查询</el-button>
          <el-button size="medium" @click='resetDateTime'>重置</el-button>
        </span>
        <span class="export-btn">
          <el-button size="medium" type="primary" @click='exportTableData'>导出</el-button>
        </span>
      </el-form>
    </div>

    <div class="tableContent">
      <el-table highlight-current-row v-loading="tableLoading" :data="tableData" max-height="620" border>
         <el-table-column width='100' fixed="left" v-for="(item,idx) in fixedColumnList" :sortable="item.isSortable===true" :key="'fixedLt'+idx" :prop="item.prop"
           :label="item.label">
           <!-- <el-table-column :width="item.width" :label="item.numTotal" >
             <template slot-scope="scope">
               <div class="cellItem">
                 {{scope.row[item.prop]}}
               </div>
             </template>
           </el-table-column> -->
         </el-table-column>

        <el-table-column  :class-name="['totalOrder'].includes(item.prop)?'boldColumnClass':''" v-for="(item,idx) in leftColumnList" :key="'left'+idx" :sort-method="percentageSortMethod(item.prop)" :sortable="item.isSortable===true" :prop="item.prop"
          :label="item.label">
          <el-table-column :class-name="['totalOrder'].includes(item.prop)?'boldColumnClass':''"  :width="item.width" :label="item.numTotal" >
            <template slot-scope="scope">
              <div class="cellItem">
                {{scope.row[item.prop]}}
              </div>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column  :class-name="['cancelledQtyDay1','delayQtyDay1'].includes(item.prop)?'boldColumnClass':''" v-for="(item,idx) in rightColumnList" :key="'right'+idx" :sort-method="percentageSortMethod(item.prop)" :sortable="item.isSortable===true" :prop="item.prop" :label="item.label">
          <el-table-column :class-name="['cancelledQtyDay1','delayQtyDay1'].includes(item.prop)?'boldColumnClass':''" :label="item.numTotal" :width="item.width">
            <template slot-scope="scope">
              <div class="cellItem" @click="showDetail(scope.row,item.prop,scope.row[item.prop])" :class="scope.row[item.prop]>0?'active_bg':''">
                {{scope.row[item.prop]}}
              </div>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <div class="cellItem">
              <el-button type="text" @click="toDetail(scope.row)">查看详情</el-button>
            </div>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination class="tr"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[50, 100, 200, 500, 1000]"
        :page-size="pageSize"
        layout="sizes, prev, next">
      </el-pagination>
    </div>

    <el-dialog width="1300px" title="违约详情" :close-on-click-modal="false" append-to-body :visible.sync="areaDetailVisible">
      <breachContract ref="areaDetailTable" :breakType="breakType" :vendorId="dialogVendorId" :startAt="dialogStartAt" :endAt="dialogEndAt" :breakCodes="dialogBreakCodes" :breakDay="dialogBreakDay"></breachContract>
    </el-dialog>

  </div>
</template>

<script>
  import { downloadUrlFile } from '@/utils/functions';
  import {
    getVendorList,
    getSystemList,
    getVendorType,
    getCountryList,
    getUserTypeList,
    getProductSourceTypeList,//商品接入方式
    getStockTypeList,//库存接入方式
    getSupplyPriceMethodList,//供货价格方式
    getUserList,//运营列表
    businessRegionList
  } from '../../buyershop/api';
  import {
    formatDateTime,
    changeParams
  } from "@/utils/functions";
  import {
    fixedColumnList,
    leftColumnList,
    rightColumnList
  } from './config/index';
  import {searchPerformanceList,getPerformanceOrderList,getEnumOrderBreak,exportPerformanceList} from './api';
  import breachContract from './breachContract';
  export default {
    data() {
       var searchDateRule = (rule, value, callback) => {
         if (value == ('' || undefined)) {
           callback(new Error('请选择查询时间'));
         } else{
             let [startTime,endTime] = value
             let createdAtBeginTime = new Date(startTime).getTime()
             let createdAtEndTime = new Date(endTime).getTime()
             if(createdAtEndTime<createdAtBeginTime){
                callback(new Error('结束时间必须大于等于开始时间'));
             }
             // if(createdAtEndTime-createdAtBeginTime >= 24 * 60 * 60 * 1000 * 31){
             //   callback(new Error('时间范围最大跨度1个月'));
             // }else if(createdAtEndTime<createdAtBeginTime){
             //   callback(new Error('结束时间必须大于等于开始时间'));
             // }
             else{
               callback();
             }
         }
       };
      return {
        fixedColumnList,
        leftColumnList,
        rightColumnList,
        searchForm: {
          searchDate: "",
          vendorAliasId: [],
          vendorId: [],
          addressCountryIdList: [],
          businessRegionId: null,
          boutiqueSaleConcatId: null,
          boutiqueAssistantId: null,
        },
        pageNo: 1,
        pageSize: 200,
        searchFormRules: {
          searchDate: {
            validator: searchDateRule,
            trigger: 'change'
          }
        },
        tableData: [],
        areaDetailVisible: false, //区域详情
        vendorList:[],//店铺枚举列表
        businessRegionName:"",
        tableLoading:false, //缓冲loading
        countryList: [],
        boutiqueBdList: [],
        breakType: 0,
        dialogVendorId: null,
        dialogStartAt: null,
        dialogEndAt: null,
        dialogBreakCodes: null,
        dialogBreakDay: null,
        pickerOptions: {
          disabledDate(date) {
            const nowDate = new Date();
            nowDate.setHours(23);
            nowDate.setMinutes(59);
            nowDate.setSeconds(59);
            nowDate.setMilliseconds(999);
            if (date > nowDate) {
              return true
            }
            return false;
          }
        },
      }
    },
    components: {
      breachContract
    },
    methods: {
      exportTableData(){ //导出
          let f = this.searchForm;
          if (!f.searchDate || !f.searchDate[0]) {
            this.$message('请选择时间')
            return;
          }
          if (f.searchDate && f.searchDate.length === 2 && f.searchDate[1]) {
            var startAt =f.searchDate[0]
            var endAt =f.searchDate[1]
          }
          let {vendorId, vendorAliasId} = f
          let {businessRegionId} = this.$route.query
          exportPerformanceList({
              startAt,
              endAt,
              vendorIds: vendorAliasId.length > 0 ? vendorAliasId : vendorId,
              businessRegionId,
              addressCountryIdList: f.addressCountryIdList,
              boutiqueAssistantId: f.boutiqueAssistantId,
              boutiqueSaleConcatId: f.boutiqueSaleConcatId,
          }).then(res=>{
              if(res&&res.data&&res.data.success){
                this.$message.success('导出列表成功')
                let resData = res.data.data
                downloadUrlFile(resData)
              }
          })
      },
      handleCurrentChange(pageNo) {
        this.pageNo = pageNo;
        this.searchAreaList();
      },
      handleSizeChange(pageSize) {
        this.pageSize = pageSize;
        this.searchAreaList();
      },
      searchAreaList(){
        let f = this.searchForm;
        this.$refs["searchForm"].validate((valid) => {
          if (valid) {
            if (f.searchDate && f.searchDate.length === 2 && f.searchDate[1]) {
              var startAt =f.searchDate[0]
              var endAt =f.searchDate[1]
            }
            let {vendorId, vendorAliasId} = f
            let {businessRegionId} = this.$route.query
            searchPerformanceList(changeParams({
               startAt,
               endAt,
               vendorIds: vendorAliasId.length > 0 ? vendorAliasId : vendorId,
               businessRegionId,
               addressCountryIdList: f.addressCountryIdList,
               boutiqueAssistantId: f.boutiqueAssistantId,
               boutiqueSaleConcatId: f.boutiqueSaleConcatId,
               pageNo: this.pageNo,
               pageSize: this.pageSize,
            })).then(res=>{
              let {total,pvs} = (res.data&&res.data.data || [])
              this.tableData = (pvs || []).map(item=>{
                return {
                  ...item,
                  serviceIndex:item.serviceIndex + "%",
                  serviceIndexNum:item.serviceIndex,
                  totalCancelProportion:item.totalCancelProportion +"%",
                  totalCancelProportionNum:item.totalCancelProportion,
                  totalDelayProportion:item.totalDelayProportion + "%",
                  totalDelayProportionNum:item.totalDelayProportion,
                  errorOrMissQtyProportion:item.errorOrMissQtyProportion + "%",
                  errorOrMissQtyProportionNum:item.errorOrMissQtyProportion,
                  flawQtyProportion:item.flawQtyProportion + "%",
                  flawQtyProportionNum:item.flawQtyProportion
                }
              })
              this.setColumnListTotal(total) //设置列总和
              this.tableLoading = false
            }).catch(err=>{
              this.tableLoading = false
            })
          } else {
            return false;
          }
        })
      },
      setColumnListTotal(total){ //设置列总和
          let fixedColumnList = this.fixedColumnList
          let leftColumnList = this.leftColumnList
          let ltColumnList = [...fixedColumnList,...leftColumnList]
          for(let key in total){
              for(let item of ltColumnList){
                   if((total[key] || total[key]===0)&&item.prop == key){
                       if(['serviceIndex','totalCancelProportion','totalDelayProportion','errorOrMissQtyProportion','flawQtyProportion'].includes(item.prop)){
                         item.numTotal = String(total[key]) + "%"
                       }else{
                         item.numTotal = String(total[key])
                       }
                   }
              }
              for(let item of this.rightColumnList){
                   if((total[key] || total[key]===0)&&item.prop == key){
                       if(['errorOrMissQtyProportion','flawQtyProportion'].includes(item.prop)){
                         item.numTotal = String(total[key]) + "%"
                       }else{
                         item.numTotal = String(total[key])
                       }
                   }
              }
          }
      },
      resetDateTime() { //重置
        this.$refs["searchForm"].resetFields()
        this.setDefaultDate();
      },
      setDefaultDate() { //设置默认时间一个月
        this.tableLoading = true
        let {searchDate} = this.$route.query
        let [createdAtBegin,createdAtEnd] = searchDate.split(',')
        this.searchForm.searchDate = [new Date(createdAtBegin + ' 00:00:00').getTime(), new Date(createdAtEnd + ' 23:59:59').getTime()]
        this.searchAreaList()
        // let day1 = new Date().getTime() - 24 * 60 * 60 * 1000 * 30; //默认时间30天
        // let day2 = new Date().getTime();
        // let createdAtBegin = formatDateTime(
        //   day1,
        //   "yyyy-MM-dd"
        // );
        // let createdAtEnd = formatDateTime(
        //   day2,
        //   "yyyy-MM-dd"
        // );
        // let searchDate = [createdAtBegin, createdAtEnd]
        // this.searchForm.searchDate = searchDate
        // this.searchAreaList()
      },
      showDetail(row,prop,num) { //展示异常详情
        if (num > 0) {
          if (prop.includes('cancelledQtyDay') || prop.includes('confirmCancelledQty')) {
            this.breakType = 0;
          } else if (prop.includes('delayQtyDay')) {
            this.breakType = 1;
          } else if (prop.includes('errorOrMissQty')) {
            this.breakType = 2;
          } else if (prop.includes('flawQty')) {
            this.breakType = 3;
          }
          let startAt =this.searchForm.searchDate[0]
          let endAt =this.searchForm.searchDate[1]
          let { vendorId } = row
          this.areaDetailVisible = true
          this.dialogVendorId = vendorId;
          this.dialogStartAt = startAt;
          this.dialogEndAt = endAt;
          this.dialogBreakCodes = this.getBreakCodes(prop);
          this.dialogBreakDay = this.getBreakDay(prop);
          this.$nextTick(() => {
            this.$refs.areaDetailTable.init();
          })
        } else {
          return false;
        }
      },
      getBreakCodes(prop){
        if(prop.indexOf('cancel')>-1){
          return ['01','02']
        }else if(prop.indexOf('delay')>-1){
          return ['03']
        }else if(prop == 'errorOrMissQty'){
          return ['04','05']
        }else if(prop == 'flawQty'){
          return ['06']
        }else if(prop == 'confirmCancelledQty'){
          return ['02']
        }else{
          return null
        }
      },
      getBreakDay(prop){
          return prop.match(/\d+/g)&&prop.match(/\d+/g)[0]
      },
      toDetail(row) { //跳转单店详情页
        let {vendorId,vendorName} = row
        let {businessRegionId,searchDate} = this.$route.query
        window.open(`/#/datacheck/shopdetail?vendorId=${vendorId}&businessRegionId=${businessRegionId}&vendorName=${vendorName}&searchDate=${searchDate}`)
      },
      percentageSortMethod(itemProp){ //百分比排序
          if(['serviceIndex','totalCancelProportion','totalDelayProportion','errorOrMissQtyProportion','flawQtyProportion'].includes(itemProp)){
              return function(a,b){
                  let prop = itemProp+"Num"
                  return  a[prop] - b[prop]
              }
          }else{
            return null
          }
      },
    },
    mounted() {
      this.setDefaultDate()
      let {businessRegionName} = this.$route.query
      this.businessRegionName = businessRegionName

      searchPerformanceList(changeParams({
          startAt: this.searchForm.searchDate[0],
          endAt: this.searchForm.searchDate[1],
          businessRegionId: this.$route.query.businessRegionId,
      })).then(res => {
        this.vendorList = res.data.data.pvs.map(item => {
          return {
            value: item.vendorId,
            label: item.vendorName,
            vendorNameAlias: item.vendorNameAlias,
          }
        });
      })

      getCountryList().then(res=>{
        this.countryList = res && res.data && (res.data.data || []).map(item => {
          return {
            value: item.addressCountryId,
            label: item.name
          }
        })
      })
      getUserList().then(res => {
        this.boutiqueBdList = res && res.data.map(item => {
          return {
            value: item.deptUserId,
            label: item.deptUserName
          }
        })
      })
    },
  }
</script>

<style lang="less">
  .areaDetail {
    .el-table--border td {
      padding: 0;
    }
    .el-table td, .el-table th {
      padding: 0 ;
    }
    .el-table th>.cell {
      height: 35px;
      line-height: 35px;
    }
    .el-table .el-table__row .cell {
      height: 30px;
      line-height: 30px;
      padding: 0;
      .cellItem{
        height: 30px;
        line-height: 30px;
        .el-button{
          height: 30px;
          line-height: 0px;
        }
      }
    }
    .el-table__body tr.current-row>td{
      background-color: #e9e9e9 !important;
    }


    .cellItem {
      padding-left: 12px;

    }

    .active_bg {
      background-color: #FFC7CE !important;
      color: #cc7c81;
      cursor: pointer;
    }
    // 加粗分界线
    .boldColumnClass{
        .cellItem{
          border-left: 1px solid #ddecd6
        }
        .cell {
          border-left: 6px solid #ddecd6
        }
    }
  }
</style>
<style lang="less" scoped>
  .areaDetail {
    padding: 20px;
    h2 {
      margin-bottom: 10px;
    }
    .dateSearch {
      padding-left: 40px;
      margin-bottom: 0px;
      position: relative;
      .tips {
        color: #c2c2c2;
        margin: 0 10px;
      }

      .form-btn {}

      .export-btn{
        position: absolute;
        right: 0;
      }
    }

    .tableContent {
      margin-bottom: 10px;


    }




  }
  .tr {
    text-align: right;
  }
</style>
